import IntroductionModal from './IntroductionModal';

export default IntroductionModal;
